import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Anchor, AvatarProvider } from 'components/Elements'

export const Logo = ({ data = {}, ...props }) => {
  const { t } = useTranslation()

  const { user } = data

  const company_logo = user?.employer_profile?.company_logo

  return (
    <Anchor to={`/employers/${user?.id}`}>
      <AvatarProvider className={'me-2'} variant={'logo'} avatar={company_logo} size={'size_3'} />
    </Anchor>
  )
}

Logo.propTypes = {
  data: PropTypes.object,
}
